export default function Badge({ children, variant = 'default' }) {
  const variants = {
    default: 'bg-surface-hover text-text-secondary border-border',
    neutral: 'bg-surface-hover text-text-tertiary border-border',
    daily: 'bg-accent-muted text-accent border-accent/20',
    weekly: 'bg-weekly-light text-weekly border-weekly/20',
    monthly: 'bg-monthly-light text-monthly border-monthly/20',
    success: 'bg-success-light text-success border-success/20',
    owner: 'bg-surface-hover text-text-secondary border-border',
  };

  return (
    <span
      className={`
        inline-flex items-center
        px-2 py-0.5
        rounded-md
        text-[9px] font-semibold uppercase tracking-wide
        border
        whitespace-nowrap
        transition-colors duration-150
        ${variants[variant] || variants.default}
      `}
    >
      {children}
    </span>
  );
}
